
var preact = require('preact');
var hooks = require('preact/hooks');
module.exports = {"attributes":{"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M8 6.333c0-.552.597-1 1.333-1h8c.737 0 1.334.448 1.334 1 0 .553-.597 1-1.334 1h-8c-.736 0-1.333-.447-1.333-1zM5 12v12c0 .184.15.333.333.333h16c.184 0 .334-.15.334-.333v-2.667a1 1 0 011.49-.87l3.058 1.723a1 1 0 01.216.164c.21.21.569.061.569-.236v-8.229a.333.333 0 00-.569-.235 1 1 0 01-.216.164l-3.057 1.724a1 1 0 01-1.491-.872V12a.333.333 0 00-.334-.334h-16A.333.333 0 005 12zm.333-2.334h16A2.333 2.333 0 0123.667 12v.955l1.461-.825C26.61 10.818 29 11.858 29 13.885v8.23c0 2.026-2.39 3.067-3.872 1.754l-1.461-.824V24a2.333 2.333 0 01-2.334 2.333h-16A2.333 2.333 0 013 24V12a2.333 2.333 0 012.333-2.334z\" fill=\"currentColor\" fill-rule=\"evenodd\"/>"}
var attributes = module.exports.attributes;
var content = module.exports.content;

module.exports = function (props) {
	var ref = hooks.useRef();

	hooks.useEffect(function () {
		var div = document.createElement('div');
		div.innerHTML = '<svg>' + content + '</svg>';

		var source = div.firstChild;
		var dest = ref.current;

		while (source.firstChild) {
			dest && dest.appendChild(source.firstChild);
		}
	}, []);

	return preact.h('svg', Object.assign({ ref: ref }, attributes, props));
};
